import { useMemo } from "react";
import { usePermissions } from "./usePermissions";

export function useCrudPermissions(permissionGroup) {
  const { hasPermission } = usePermissions();

  const viewPermission = permissionGroup?.VIEW;
  const createPermission = permissionGroup?.CREATE;
  const updatePermission = permissionGroup?.UPDATE;
  const deletePermission = permissionGroup?.DELETE;
  const imageUpdatePermission = permissionGroup?.IMAGE_UPDATE;

  return useMemo(
    () => ({
      canView: viewPermission ? hasPermission(viewPermission) : false,
      canCreate: createPermission ? hasPermission(createPermission) : false,
      canUpdate: updatePermission ? hasPermission(updatePermission) : false,
      canDelete: deletePermission ? hasPermission(deletePermission) : false,
      canImageUpdate: imageUpdatePermission
        ? hasPermission(imageUpdatePermission)
        : false,
    }),
    [
      createPermission,
      deletePermission,
      hasPermission,
      imageUpdatePermission,
      updatePermission,
      viewPermission,
    ],
  );
}
